/**
 * Janitorial product detail content — auto-generated by /tmp/build_janitorial_catalog.py
 * Source: /tmp/janitorial_details.json (scraped from sterilemate.com).
 * DO NOT EDIT MANUALLY — re-run the scraper + builder to refresh.
 * Products: 45 / 45
 */

const ASSET_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/static/janitorial`;
const A = (p) => `${ASSET_BASE}/${p}`;
import { JANITORIAL_MANUAL_DETAILS } from "@/data/janitorialManualDetails";

export const JANITORIAL_PRODUCT_DETAILS = {
  "SM-AIR-001": {
    title: "705 Series – Air Vacuums",
    lead: [
      "Compressed air vacuums, ideal for a wide range of markets and applications, the 705 Series of air vacuums uses compressed air and the venturi principle to create a vacuum of exceptionally high flow and high static lift. Capable of lifting or moving an extensive variety of solid or liquid materials, options are available in electrostatically applied painted tanks and stainless steel, and a large range of tank sizes, filter arrangements, venturi and hoses sizes are available.",
    ],
    sections: [
      {
        heading: "Key Features",
        items: [
          "180″ of waterlift on every air vacuum model",
          "High CFM from 166cfm (4 gal) to 728 cfm (55 gal with quad jets)",
          "Capable of filling a 55 gallon barrel with liquid in less than 60 seconds",
        ],
      },
      {
        heading: "General Overview",
        items: [
          "No moving parts to replace",
          "No motors or switches to replace",
          "Silenced down to low 80 dba",
          "Available in stainless steel or electrostatically applied painted tanks",
          "Uses compressed air and the venturi principle to create a vacuum of exceptionally high flow and high static lift",
          "Ideal for areas where standard voltage is not available",
          "Capable of lifting or moving an extensive variety of solid or liquid materials",
          "Large range of tank sizes, filter arrangements, venturi and hose sizes, tools & attachments for wet/dry pick up",
          "Optional HEPA filters available on select models",
          "6 gallon, 15 gallon & 55 gallon units available",
          "Uses the venturi principle",
        ],
      },
      {
        heading: "Parts and Instruction Manuals",
        paragraphs: [
          "Compressed air vacuums, ideal for a wide range of markets and applications, the 705 Series of air vacuums uses compressed air and the venturi principle to create a vacuum of exceptionally high flow and high static lift. Capable of lifting or moving an extensive variety of solid or liquid materials, options are available in electrostatically applied painted tanks and stainless steel, and a large range of tank sizes, filter arrangements, venturi and hoses sizes are available.",
        ],
        items: [
          "705 Air Vacuum 6 Gallon Parts and Instruction Manual",
          "705 Air Vacuum 15/55 Gallon Parts and Instruction Manual",
          "705 Air Vacuum ULPA 6 Gallon Parts and Instruction Manual",
          "705 Air Vacuum ULPA 15/55 Gallon Parts and Instruction Manual",
        ],
      },
    ],
    images: [
      A("air-vacuums/SM-AIR-001/705-Series-–-Air-Vacuums.webp"),
    ],
    pdfs: [
      {
        file: A("air-vacuums/SM-AIR-001/705-Series-–-Air-Vacuums-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("air-vacuums/SM-AIR-001/705-Air-Vacuum-6-Gallon-Parts-and-Instruction-Manual.pdf"),
        label: "705 Air Vacuum 6 Gallon Parts and Instruction Manual",
      },
      {
        file: A("air-vacuums/SM-AIR-001/705-Air-Vacuum-15-55-Gallon-Parts-and-Instruction-Manual.pdf"),
        label: "705 Air Vacuum 15/55 Gallon Parts and Instruction Manual",
      },
      {
        file: A("air-vacuums/SM-AIR-001/705-Air-Vacuum-ULPA-6-Gallon-Parts-and-Instruction-Manual.pdf"),
        label: "705 Air Vacuum ULPA 6 Gallon Parts and Instruction Manual",
      },
      {
        file: A("air-vacuums/SM-AIR-001/705-Air-Vacuum-ULPA-15-55-Gallon-Parts-and-Instruction-Manual.pdf"),
        label: "705 Air Vacuum ULPA 15/55 Gallon Parts and Instruction Manual",
      },
      {
        file: A("air-vacuums/SM-AIR-001/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-ATP-001": {
    title: "CleanRead™ Handheld ATP Testing Device",
    lead: [
      "The CleanRead™ Handheld ATP Testing Device is designed for facilities demanding quick, easy-to-use, and reliable solutions for assessing cleaning protocols and verifying efficacy within 15 seconds.",
    ],
    images: [
      A("atp/SM-ATP-001/hand-held-banner.webp"),
      A("atp/SM-ATP-001/cleanread-02-1.webp"),
      A("atp/SM-ATP-001/hand-held-banner-1.webp"),
      A("atp/SM-ATP-001/cleanread-01-1.webp"),
    ],
    pdfs: [
      {
        file: A("atp/SM-ATP-001/CleanReadHandheld-BvXHlfsC.pdf"),
        label: "Download Brochure",
      },
    ],
  },
  "SM-ATP-002": {
    title: "Next Gen AI Visual Inspection Borescope",
    lead: [
      "Advanced AI powered visual inspection tool for cannulated instruments.",
    ],
    pdfs: [
      {
        file: A("atp/SM-ATP-002/clearead-vib-ifu.pdf"),
        label: "Download Brochure",
      },
    ],
  },
  "SM-ATP-003": {
    title: "CleanOps App",
    lead: [
      "Structured Guidance = Better Performance. Less Repetition.",
    ],
    images: [
      A("atp/SM-ATP-003/cleanops-apps-image-01.webp"),
    ],
  },
  "SM-ATP-004": {
    title: "Sterile Nasal Flocked Swab",
    lead: [
      "Innovative Technology for Sample Collection & Diagnostics",
      "The Nasal Flocked Swab is used for cell & virus specimen collection and has been designed specifically for Nasopharyngeal clinical diagnostics. The flocked swab is ideal for collecting large number of cells and instantly releasing the specimen cells into the transport medium.",
    ],
    sections: [
      {
        heading: "Features",
        items: [
          "Ergonomic and Anatomic Design: Perpendicular nylon fibers act like a soft brush, improving patient comfort and efficiency in cell specimen collection.",
          "Superior Sample Elution: The open fiber structure allows the specimen cells to instantly dislodge into the liquid medium.",
          "Increased Assay Sensitivity: Flocked swabs are proven to elute >95% of the original sample rapidly thus easily resulting in improved assay sensitivity.",
          "Quantitative Volume Transfer: Measurable and consistent uptake and transfer from patient to the test tube. Flocked Swab has no internal mattress core to trap the sample like traditional fiber wound swabs.",
          "Certified Free of Inhibitors and Interference: Collection swabs are certified DNASE, RNASE-free and human DNA-free. They are also free of any PCR inhibitors.",
        ],
      },
    ],
    images: [
      A("atp/SM-ATP-004/sterile-nasal-flocked-swab.webp"),
    ],
  },
  "SM-ATP-005": {
    title: "COVID-19 Viral Transport Medium",
    lead: [
      "Innovative Technology for Sample Collection & Diagnostics",
      "Active Viral Transport Medium offered by Empire Bio Diagnostics is for the preservation and transportation of viruses, such as coronavirus (COVID-19). Swab of choice sold separately.",
    ],
    sections: [
      {
        heading: "Features",
        items: [
          "18 Month Shelf Life.",
          "Room temperature stable.",
          "Available in 3ml.",
          "Provides a pH balanced environment.",
          "A phenol red pH indicator provides a visual gauge of the medium integrity throughout the storage and life of the product.",
          "Includes antibiotics to inhibit bacteria and fungal flora.",
        ],
      },
    ],
    images: [
      A("atp/SM-ATP-005/covid-19-viral-transport-medium.webp"),
    ],
  },
  "SM-ATP-006": {
    title: "COVID-19 Collection & Transport Kit Viral Transport Medium & Flocked Swab",
    lead: [
      "Innovative Technology for Sample Collection & Diagnostics",
      "The Viral Transport Medium & Flocked Swab Kit offered by Empire Bio Diagnostics is for the collection, preservation, and transportation of viruses, such as coronavirus (COVID-19).",
    ],
    sections: [
      {
        heading: "Features",
        items: [
          "18 Month Shelf Life.",
          "Room temperature stable.",
          "Available in 3ml.",
          "Provides a pH balanced environment.",
          "A phenol red pH indicator provides a visual gauge of the medium integrity throughout the storage and life of the product.",
          "Includes antibiotics to inhibit bacteria and fungal flora.",
          "Increased Assay Sensitivity.",
          "Ergonomic and Anatomic Design.",
          "Improved Sample Collection.",
          "Certified Free of Inhibitors and Interference.",
          "Highly Suited to Automation.",
        ],
      },
    ],
    images: [
      A("atp/SM-ATP-006/covid-19-collection-and-transport-kit-viral-transport-medium-and-flocked-swab-transport-kit.webp"),
    ],
  },
  "SM-ATP-007": {
    title: "CleanRead™ Reporting Software",
    lead: [
      "RLU test values are seamless synchronized from the CleanRead™ Handheld device to a robust dashboard, delivering actionable real-time results.",
      "Generate customizable reports, monitoring summaries and access them everywhere at anytime through our website.",
    ],
    sections: [
      {
        heading: "Data driven decisions for an efficient workflow.",
        paragraphs: [
          "Generate customizable reports, monitoring summaries and access them everywhere at anytime through our website.",
        ],
      },
    ],
    images: [
      A("atp/SM-ATP-007/cleanread-reporting-software-reporting.webp"),
      A("atp/SM-ATP-007/cleanread-reporting-software-reporting.webp"),
      A("atp/SM-ATP-007/cleanread-reporting-software-data-driver.webp"),
      A("atp/SM-ATP-007/cleanread-reporting-software-reporting.webp"),
      A("atp/SM-ATP-007/cleanread-reporting-software-data-driver.webp"),
    ],
  },
  "SM-ATP-008": {
    title: "CleanRead™ Surface Protein Detection Swabs",
    lead: [
      "Measure protein contamination on any scope, cannulated instrument or surface in 10 minutes!",
      "CleanRead™ Surface Protein Detection Swab provides a rapid, simple and quantitative way to measure protein contamination on the surface of surgical instruments, scopes, washer-disinfectors, exam rooms, operating rooms, restrooms, waiting rooms – anywhere that can harbor protein contaminants.",
    ],
    sections: [
      {
        heading: "Features",
        items: [
          "All-in-one sampling device.",
          "Unique liquid-stable reagent.",
        ],
      },
    ],
    images: [
      A("atp/SM-ATP-008/cleanread-surface-protein-detection-swabs-surface-protine.webp"),
    ],
    pdfs: [
      {
        file: A("atp/SM-ATP-008/Surface_ATP_Detection_Swab_rev-1.pdf"),
        label: "Download Brochure",
      },
    ],
  },
  "SM-ATP-009": {
    title: "CleanRead™ Aqua ATP Detection Swabs",
    lead: [
      "Monitors ATP Levels in water as a quality cleanliness indicator with results in only 15 seconds!",
      "CleanRead™ Aqua ATP Detection Swabs are self-contained ATP tests for use with CleanRead™ Handheld luminometers. Tests are used to monitor ATP levels in water as a quality cleanliness indicator. The specially formulated CleanRead™ Swab is a validated method for testing water quality throughout the healthcare environment. It is especially valuable in monitoring the cleanliness of endoscopes and cannulated medical devices. CleanRead™ Aqua ATP Detection Swabs measure both ATP contained within living cells and particulate matter (microbial ATP) as well as ATP dissolved in water (non-microbial or dead microbial ATP organisms, also referred to as biomass).",
    ],
    sections: [
      {
        heading: "Features",
        items: [
          "All-in-one sampling device.",
          "15-month shelf life (from date of mfg.) at refrigerated temperatures (36°F to 46°F) (2°C to 8°C).",
          "4 week shelf life at room temperatures (68°F) (20°C).",
          "Unique liquid-stable reagent.",
        ],
      },
    ],
    images: [
      A("atp/SM-ATP-009/cleanread-aqua-atp-detection-swabs-surface-detection.webp"),
    ],
    pdfs: [
      {
        file: A("atp/SM-ATP-009/Aqua_ATP_Detection-Swab.pdf"),
        label: "Download Brochure",
      },
    ],
  },
  "SM-ATP-010": {
    title: "CleanRead™ Surface ATP Detection Swabs",
    lead: [
      "Verify cleanliness and measure microbial contamination on any scope, cannulated instrument or surface in 15 seconds!",
      "CleanRead™ Surface ATP Detection Swab provides a rapid, simple and reliable way to verify cleanliness and measure microbial contamination on the surface of surgical instruments, scopes, washer-disinfectors, exam rooms, operating rooms, restrooms, waiting rooms – anywhere that can harbor possible contaminants.",
    ],
    sections: [
      {
        heading: "Features",
        items: [
          "All-in-one sampling device.",
          "15-month shelf life (from date of mfg.) at refrigerated temperatures (36°F to 46°F) (2°C to 8°C).",
          "4 week shelf life at room temperatures (68°F) (20°C).",
          "Unique liquid-stable reagent.",
        ],
      },
    ],
    images: [
      A("atp/SM-ATP-010/cleanread-surface-atp-detection-swabs-surface.webp"),
    ],
    pdfs: [
      {
        file: A("atp/SM-ATP-010/CleanRead-Protein-Swab.pdf"),
        label: "Download Brochure",
      },
    ],
  },
  "SM-AUT-001": {
    title: "Autonomous Floor Scrubber",
    lead: [
      "RoboScrub 20, Minuteman’s innovative automatic floor scrubber, is the efficient and effective autonomous cleaning solution for a variety of commercial settings including shopping centers, grocery stores, warehouses, and production halls.",
      "This self-driving floor scrubber utilizes built-in cameras and sensors that integrate with intuitive BrainOS® Technology to safely navigate surroundings, detect and avoid people and obstacles, and learn new paths. Its patented Aqua Stop banded brush applies soft, non-abrasive nylon bristles to deliver deep cleaning without damaging floors.",
      "Product Information",
    ],
    sections: [
      {
        heading: "Autonomous Cleaning – with reliable results!",
        paragraphs: [
          "This self-driving floor scrubber utilizes built-in cameras and sensors that integrate with intuitive BrainOS® Technology to safely navigate surroundings, detect and avoid people and obstacles, and learn new paths. Its patented Aqua Stop banded brush applies soft, non-abrasive nylon bristles to deliver deep cleaning without damaging floors.",
          "Product Information",
        ],
      },
      {
        heading: "Robotic Floor Scrubber",
        items: [
          "Exceptional maneuverability to navigate narrow aisles and complex environments",
          "Battery-operated to deliver up to four hours of operation",
          "Cleans up to 24,500 square feet per hour",
          "Designed to accommodate a range of floor types, from polished concrete to Vinyl Composite Tile (VCT)",
          "Keeps water inside the brush deck to prevent over-spraying and conserve water usage",
          "Converts to a conventional ride-on floor scrubber-drier for immediate quick cleaning needs",
        ],
      },
      {
        heading: "More Information",
        paragraphs: [
          "Features & Benefites",
          "Specifications",
          "Parts, User and Service Manuals",
          "Q: How long can the RoboScrub 20 run on one charge?\nA: The RoboScrub 20 can run up to 4 hours on two 230 Ah AGM batteries.",
          "Q: How long does it take to fully recharge the RoboScrub 20?\nA: It takes approximately 7 to 8 hours to fully charge the RoboScrub 20.",
          "Q: How many square feet per hour can it clean?\nA: The RoboScrub 20 can clean up to 24,500sq. ft. per hour (in theoretical max manual mode).",
          "Q: Can the RoboScrub 20 handle concrete, VCT, or polished floors?\nA: Yes, the RoboScrub 20 is designed to clean a range of floor types including polished concrete, Vinyl Composite Tile (VCT), and other hard indoor surfaces.",
          "Q: What sensors or AI does the RoboScrub 20 use?\nA: The RoboScrub 20 robotic scrubber is equipped with integrated 2D/3D cameras along with advanced sensors powered by intuitive BrainOS® software for obstacle avoidance and route learning. It also features LiDAR technology – Light Detection and Ranging – which uses laser pulses to measure distances and generate detailed 3D maps of objects and environments.",
          "Q: What happens if it encounters an obstacle?\nA: The RoboScrub 20 includes sensors to avoid objects as well as built-in safety features such as two auto-stop buttons, horn, anti-joy-ride detection, turn signals, and flashing beacon.",
          "Q: Can I switch to ride-on/manual operation?\nA: Yes, dual-mode allows the RoboScrub 20 to convert to a conventional ride-on scrubber for manual use by a driver.",
          "Q: Can the RoboScrub 20 send alerts or reports?\nA: Yes, via Robot Operations Center (ROC) which supports mobile alerts, usage tracking, productivity and status reporting, and remote diagnostics.",
        ],
        items: [
          "Compact programmable automated floor scrubber",
          "Intuitive BrainOS® Technology",
          "Built-in 3D and 2D cameras and sensors for navigation and routine",
          "Four hours of operating time on two Discover AGM Batteries",
          "Aqua Stop brush with non-abrasive nylon bristles for deep cleaning and a band to keep water inside the brush deck",
          "Emergency features include two Auto-Stop Buttons, Horn, Anti-Joy Ride Detection, and Turn Signals.",
          "Seven to Eight Hour Charging Time",
          "Cleaning path: 20 in/50.8 cm",
          "Productivity per hour theoretical max manual mode: 24,500 ft2 / 3106m2",
          "Brush RPM: 175",
          "Solution tank: 16 gal/60.5 L",
          "Recovery tank including demising chamber: 16 gal/60.5 L",
          "System voltage: 24 volts",
          "Battery run time: Up to 4 hours",
          "Battery: 230 Ah AGM",
          "Weight empty: 343 lbs/155.5 kg",
          "Weight empty with batteries: 615 lbs/279 kg",
          "Length: 55.5 in/140.9 cm",
          "Width: 26 in/66 cm",
          "Height: 47.5 in/120.6cm",
          "RoboScrub 20 Parts Manual",
          "RoboScrub 20 User Manual",
          "RoboScrub 20 Service Manual",
        ],
      },
    ],
    images: [
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-1.webp"),
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-2.webp"),
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-3.webp"),
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-4.webp"),
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-1.webp"),
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-2.webp"),
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-3.webp"),
      A("autonomous-floor-care/SM-AUT-001/Autonomous-Floor-Care-4.webp"),
    ],
    pdfs: [
      {
        file: A("autonomous-floor-care/SM-AUT-001/Prospekt-Minuteman-RoboScrub-20-english.pdfAdobe.pdf"),
        label: "Product Information",
      },
      {
        file: A("autonomous-floor-care/SM-AUT-001/RoboScrub-20-Parts-Manual.pdf"),
        label: "RoboScrub 20 Parts Manual",
      },
      {
        file: A("autonomous-floor-care/SM-AUT-001/RoboScrub-20-User-Manual.pdf"),
        label: "RoboScrub 20 User Manual",
      },
      {
        file: A("autonomous-floor-care/SM-AUT-001/RoboScrub-20-Service-Manual.pdf"),
        label: "RoboScrub 20 Service Manual",
      },
      {
        file: A("autonomous-floor-care/SM-AUT-001/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-CCC-001": {
    title: "Bio-Power",
    lead: [
      "A multi-purpose biological digester/odor counteractant. Its blend of 4 different bacillus strains release enzymes to break down organic debris. Use as a drain maintainer and grease trap additive. Also great for urine and other malodors. Each gallon contains 190 billion enzyme producing micro-organisms. USDA C-1. Letter of Guarantee",
    ],
    images: [
      A("commercial-cleaning-chemicals/SM-CCC-001/Bio-Power.webp"),
      A("commercial-cleaning-chemicals/SM-CCC-001/Bio-Power.webp"),
    ],
    pdfs: [
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-001/Bio-Power-Letter-of-Guarantee.pdf"),
        label: "Letter of Guarantee",
      },
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-001/Bio-Power.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-CCC-002": {
    title: "Bio-Shine – Neutral Floor Cleaner",
    lead: [
      "BIO-SHINE is a concentrated cleaner designed for resilient and natural stone floors. Bio-Shine is based on palm, coconut, sugarcane, and corn.",
      "1 gallon – Part number 910753",
    ],
    images: [
      A("commercial-cleaning-chemicals/SM-CCC-002/Bio-Shine-Neutral-Floor-Cleaner.webp"),
      A("commercial-cleaning-chemicals/SM-CCC-002/Bio-Shine-Neutral-Floor-Cleaner.webp"),
    ],
    pdfs: [
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-002/Bio-Shine-Neutral-Floor-Cleaner.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-CCC-003": {
    title: "Double’ O Seven – Peroxide Cleaner",
    lead: [
      "The one product for all your cleaning needs. The combination of hydrogen peroxide and biodegradable surfactants provides superior cleaning, deodorizing, yet is very environmentally friendly.",
      "1 Gallon – Part number 902363",
    ],
    images: [
      A("commercial-cleaning-chemicals/SM-CCC-003/Double-O-Seven-Peroxide-Cleaner.webp"),
      A("commercial-cleaning-chemicals/SM-CCC-003/Double-O-Seven-Peroxide-Cleaner.webp"),
    ],
    pdfs: [
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-003/Double-O-Seven-Peroxide-Cleaner.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-CCC-004": {
    title: "Multi-Shine – Glass and Surface Cleaner",
    lead: [
      "A non-streaking, pleasant to use glass and surface cleaner. Multi-Shine’s mildly ammoniated formula combined with special solvents and detergents help penetrate greasy fingerprints, dirt, and soil for easy removal. Use on glass, mirrors, and polished surfaces. USDA C-1. Letter of Guaranty",
    ],
    images: [
      A("commercial-cleaning-chemicals/SM-CCC-004/Multi-Shine-Glass-and-Surface-Cleaner.webp"),
      A("commercial-cleaning-chemicals/SM-CCC-004/Multi-Shine-Glass-and-Surface-Cleaner.webp"),
    ],
    pdfs: [
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-004/Multi-Shine-Glass-and-Surface-Cleaner-Letter-of-Guarantee.pdf"),
        label: "Letter of Guaranty",
      },
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-004/Multi-Shine-Glass-and-Surface-Cleaner.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-CCC-005": {
    title: "PP-Gone",
    lead: [
      "PP-Gone is a Peroxide Powered Cleaner that destroys urine odors and stains on hard and soft surfaces. PP-Gone is not just for hard surfaces, the dye free formula is safe on soft surfaces including carpet, bedding, mattresses, upholstery and clothing. It makes a great laundry pre-spot for urine and other stains. PP-Gone works effectively on human urine and animal urine odors and stains.",
      "12 quart case – Part Number 902578",
    ],
    images: [
      A("commercial-cleaning-chemicals/SM-CCC-005/PP-Gone.webp"),
      A("commercial-cleaning-chemicals/SM-CCC-005/PP-Gone.webp"),
    ],
    pdfs: [
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-005/PP-Gone.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-CCC-006": {
    title: "X-Ray – RTU Peroxide Cleaner",
    lead: [
      "The combination of hydrogen peroxide (H2O2) and biodegradable surfactants provides superior cleaning and deodorizing, yet is environmentally responsible. This is a spray ‘n wipe cleaner for all surfaces found in homes, offices, schools, industry and/or food service.",
      "12 quart case – Part Number 902388",
    ],
    images: [
      A("commercial-cleaning-chemicals/SM-CCC-006/X-Ray-RTU-Peroxide-Cleaner.webp"),
      A("commercial-cleaning-chemicals/SM-CCC-006/X-Ray-RTU-Peroxide-Cleaner.webp"),
    ],
    pdfs: [
      {
        file: A("commercial-cleaning-chemicals/SM-CCC-006/X-Ray-RTU-Peroxide-Cleaner.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-CFV-001": {
    title: "Hospital Vacuum",
    sections: [
      {
        heading: "Key Features:",
        items: [
          "Wet/Dry Vacuum, four stage filtration system includes filter protector, washable cloth filter, pre-filter, and HEPA filter",
          "HEPA filter is 99.97% efficient at .3 microns,tested in accordance with IEST-RP-CC007 standards.",
          "Rugged design, easy to maneuver stainless steel tank with heavy cast aluminum wheel assembly.",
          "Patented self-sealing/quick release intake mechanism.",
          "Indicator light on lid assembly alerts operator when filters require servicing",
          "Lid design protects motor from water damage, diffusing air alongside the tank for less disruption of ambient particulate matter resulting in a safer work environment",
          "Convenient 50’ power cord.",
          "Each unit includes packages of replacement disposable filters",
        ],
      },
      {
        heading: "General Overview",
        items: [
          "Vacuum system to control contaminants in air and on surfaces; supports proper housekeeping procedures and infection control plan.",
          "For use in any area housing immunosuppressed, high-risk patients.",
          "Collects and contains fungal, biological, lead, mold, asbestos, bacterial, or any other infectious material.",
          "Bio-Terrorism Preparedness",
          "Joint Commission Readiness",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Air Flow: 110 CFM",
          "Static Lift: 105″",
          "Tank Construction: Stainless Steel",
          "Tank Size: 15 Gallon",
          "Vacuum Power: 2.3HP",
        ],
      },
      {
        heading: "Spare Parts and Instruction Catalog",
        items: [
          "Spare Parts and Instruction Catalog",
        ],
      },
    ],
    images: [
      A("critical-filter-vacuums/SM-CFV-001/Hospital-Vacuum.webp"),
    ],
    pdfs: [
      {
        file: A("critical-filter-vacuums/SM-CFV-001/Hospital-Vacuum-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-001/Hospital-Vacuum-Spare-Parts-and-Instruction-Catalog.pdf"),
        label: "Spare Parts and Instruction Catalog",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-001/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-CFV-002": {
    title: "Mercury Recovery Vacuum System",
    lead: [
      "Specially adapted critical filter vacuum systems for the recovery of elemental mercury and mercury contaminated particulated and liquid materidals. Modular 4 element system allows units to be tailored to fit any application.",
    ],
    sections: [
      {
        heading: "Key Features:",
        items: [
          "Extremely portable, highly maneuverable vacuum system for mercury removal",
          "U.L.P.A. filters are 99.999% effective at 0.12 microns",
          "Charcoal Filter for the elimination of toxic vapors during clean-up process",
          "Each model contains a large capacity activated carbon filter",
          "Unique modular 4-element system that allows user-tailoring to fit almost any need",
          "Tool kit, which will handle most clean-up jobs, is included",
        ],
      },
      {
        heading: "General Overview",
        paragraphs: [
          "Specially adapted critical filter vacuum systems for the recovery of elemental mercury and mercury contaminated particulated and liquid materidals. Modular 4 element system allows units to be tailored to fit any application.",
        ],
      },
      {
        heading: "Available Models",
        items: [
          "C83015-01 – MRS 3 – For quick silver mercury recovery in dry applications. (15 Gal, Stainless Steel)",
          "C84015-01 – MRS 4 – For recovery of mercury immersed in water. (15 Gal, Stainless Steel)",
          "C86006-11 – MRS 6 – For quick silver mercury recovery in dry applications. (6 Gal, Stainless Steel)",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Air Flow: 115CFM(3.25m³ /min)",
          "Dry Capacity: 2.1 cu ft(.05m³ /min)",
          "Front Wheels: 3″ (8cm)",
          "Front Wheels: 3″ (8cm)",
          "Height: 46″(116cm)",
          "Power cord: 16-3/50′(15m)",
          "Rated Voltage: 115 (220)",
          "Rear Wheels: 8″ (20cm",
          "Static Lift: 110″(2,794mm)",
          "Vacuum Power: 1480 Watts",
          "Weight: 70lbs(31.5kg)",
          "Wet Capacity: 10gal(38ltr)",
          "Width: 21″(53cm)",
        ],
      },
      {
        heading: "Green Features",
        items: [
          "Allows for safe, affordable clean-up of liquid mercury and mercury contaminated soil and air",
          "Mercury Recovery Vacuum System can be tailored to fit almost any particular need",
          "MRS 3 and 4 are designed with high-quality stainless steel 15 gallon tanks",
          "All units feature a 115v or 220v AC/DC air-cooled motor",
        ],
      },
      {
        heading: "Spare Parts and Instruction Catalog",
        items: [
          "Spare Parts and Instruction Catalog",
        ],
      },
    ],
    images: [
      A("critical-filter-vacuums/SM-CFV-002/Mercury-Recovery-Vacuum-System.webp"),
      A("critical-filter-vacuums/SM-CFV-002/Mercury-Recovery-Vacuum-System-02.webp"),
      A("critical-filter-vacuums/SM-CFV-002/Mercury-Recovery-Vacuum-System.webp"),
      A("critical-filter-vacuums/SM-CFV-002/Mercury-Recovery-Vacuum-System-02.webp"),
    ],
    pdfs: [
      {
        file: A("critical-filter-vacuums/SM-CFV-002/Mercury-Recovery-Vacuum-System-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-002/Mercury-Recovery-Vacuum-System-Spare-Parts-and-Instruction-Catalog.pdf"),
        label: "Spare Parts and Instruction Catalog",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-002/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-CFV-003": {
    title: "X-839 Vacuum Series",
    lead: [
      "The Minuteman x839 H.E.P.A. Vacuum Series is available with polyethylene, stainless steel or painted tanks to best suit your needs. This series is easy and economical to use. The Tanks: Standard as dry only units, all 15 and 55 gallon vacuums have wet/dry recovery capabilities with an optional 1:1 adapter and water shut-off. The 55 gallon vacs are equipped with a painted tank, dolly and handle for easy maneuverability. The Lid Assemblies: Three separate vacuum motor assemblies, with waterlifts of 85″, 105″ and 130″ can be matched to several tanks to customize the units.",
    ],
    sections: [
      {
        heading: "Downloads",
        items: [
          "Download X-839 Series Lit",
          "Download Static Conductive Vacuum Lit",
        ],
      },
      {
        heading: "General Overview",
        paragraphs: [
          "The Minuteman x839 H.E.P.A. Vacuum Series is available with polyethylene, stainless steel or painted tanks to best suit your needs. This series is easy and economical to use. The Tanks: Standard as dry only units, all 15 and 55 gallon vacuums have wet/dry recovery capabilities with an optional 1:1 adapter and water shut-off. The 55 gallon vacs are equipped with a painted tank, dolly and handle for easy maneuverability. The Lid Assemblies: Three separate vacuum motor assemblies, with waterlifts of 85″, 105″ and 130″ can be matched to several tanks to customize the units.",
        ],
      },
      {
        heading: "Available Units",
        items: [
          "C80106-01 – 6 gallon, Stainless Steel, dry applications (Pictured Above)",
          "C83918-00 – 15 gallon, Stainless Steel, dry applications",
          "C83905-05 – 15 gallon, Polyethylene, dry applications",
          "C83905-16 – 15 gallon, Polyethylene, wet/dry applications",
          "C83905-55 – 55 gallon, Painted, wet/dry applications",
        ],
      },
      {
        heading: "Ease of Use",
        items: [
          "H.E.P.A. Filter",
          "Minuteman H.E.P.A. (High Efficiency Particulate Air) filters feature an exclusive high tensile strength surface membrane co-poly laminated media for increased durability.",
          "A seamless, lightweight aluminum filter housing eliminates potential problems.",
        ],
      },
      {
        heading: "Green Features",
        items: [
          "U.L.P.A. & H.E.P.A filters availalbe on certain models.",
          "Sound level < = 70dBs",
          "Ergonomically designed for ease of use",
        ],
      },
      {
        heading: "Spare Parts and Instruction Catalogs",
        items: [
          "C80106-01 – 6 gallon, Stainless Steel, dry applications (Pictured Above)",
          "C83918-00 – 15 gallon, Stainless Steel, dry applications",
          "C83905-05 – 15 gallon, Polyethylene, dry applications",
          "C83905-16 – 15 gallon, Polyethylene, wet dry applications",
          "C83905-55 – 55 gallon, Pained, wet/dry applications",
        ],
      },
    ],
    images: [
      A("critical-filter-vacuums/SM-CFV-003/X-839-Vacuum-Series-01.webp"),
      A("critical-filter-vacuums/SM-CFV-003/X-839-Vacuum-Series-02.webp"),
      A("critical-filter-vacuums/SM-CFV-003/X-839-Vacuum-Series-03.webp"),
      A("critical-filter-vacuums/SM-CFV-003/X-839-Vacuum-Series-01.webp"),
      A("critical-filter-vacuums/SM-CFV-003/X-839-Vacuum-Series-02.webp"),
      A("critical-filter-vacuums/SM-CFV-003/X-839-Vacuum-Series-03.webp"),
    ],
    pdfs: [
      {
        file: A("critical-filter-vacuums/SM-CFV-003/X-839-Series-Lit.pdf"),
        label: "Download X-839 Series Lit",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-003/Static-Conductive-Vacuum-Lit.pdf"),
        label: "Download Static Conductive Vacuum Lit",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-003/C80106-01-–-6-gallon-Stainless-Steel-dry-applications.pdf"),
        label: "C80106-01 – 6 gallon, Stainless Steel, dry applications (Pictured Above)",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-003/C83918-00-–-15-gallon-Stainless-Steel-dry-applications.pdf"),
        label: "C83918-00 – 15 gallon, Stainless Steel, dry applications",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-003/C83905-05-–-15-gallon-Polyethylene-dry-applications.pdf"),
        label: "C83905-05 – 15 gallon, Polyethylene, dry applications",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-003/C83905-16-–-15-gallon-Polyethylene-wet-dry-applications.pdf"),
        label: "C83905-16 – 15 gallon, Polyethylene, wet dry applications",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-003/C83905-55-–-55-gallon-Pained-wet-dry-applications.pdf"),
        label: "C83905-55 – 55 gallon, Pained, wet/dry applications",
      },
      {
        file: A("critical-filter-vacuums/SM-CFV-003/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-DIL-001": {
    title: "128 E-Fecticide",
    lead: [
      "Hospital grade disinfectant cleaner. Neutral PH makes this product safe for floors. Hospital grade, broad spectrum efficacy includes HIV, HBV, MRSA, VRE. Disinfectant, bactericidal, fungicidal, virucidal, mildewstatic. 1:128",
    ],
    sections: [
      {
        heading: "Fast Kill Disinfectant",
        paragraphs: [
          "Hospital grade disinfectant cleaner. Neutral PH makes this product safe for floors. Hospital grade, broad spectrum efficacy includes HIV, HBV, MRSA, VRE. Disinfectant, bactericidal, fungicidal, virucidal, mildewstatic. 1:128",
        ],
      },
    ],
    images: [
      A("dilution-control/SM-DIL-001/128-E-Fecticide-2L.webp"),
      A("dilution-control/SM-DIL-001/128-E-Fecticide-2L.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-001/128Efecticidespec2LUS12-1-21.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-002": {
    title: "16 Neutra-Zyme",
    lead: [
      "Neutral pH 7 Non-alkaline formula helps retain high gloss on finished floors. Simply the best cleaner for UHS programs. Use on VCT, vinyl, rubber, laminate, sealed wood, marble, grouted tile, and natural stone floors.",
      "Neutra-Zyme is fortified with Bio-Zyme, a proprietary blend of bacterial spores and natural enzymes that provide superior cleaning power, both immediate and residual. The enzymes provide immediate consumption and neutralization of soils, while the bacterial spores remain on the surface and provide residual cleaning long after the cleaning.",
    ],
    images: [
      A("dilution-control/SM-DIL-002/16-Neutra-Zyme.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-002/16Neutra-Zymespec12-14-19.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-003": {
    title: "19 Enzy-Clean",
    lead: [
      "19 Enzy-Clean is a biological and enzymatic floor degreaser in the Multi-Task concentrate system. It contains a synergistic blend of natural microorganisms that releases enzymes to consume and break down food, grease, and organic material.",
    ],
    images: [
      A("dilution-control/SM-DIL-003/19-Enzy-Clean.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-003/19enzycleanspec12-26-19.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-004": {
    title: "2 Multi-Shine",
    lead: [
      "Streak-free cleaning of windows, mirrors, polished and glossy surfaces. Use on all glass and mirrors, brass, aluminum, vinyl, plastic, polycarbonate, Formica, stainless steel, etc. Ammonia, alcohol, and solvent free. USDA C-10",
    ],
    images: [
      A("dilution-control/SM-DIL-004/2-Multi-Shine.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-004/2-Multi-Shine.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-005": {
    title: "256 Century",
    lead: [
      "A no-rinse, neutral pH, hospital disinfectant cleaner. 256 Century Q is efficacious against Rotavirus, Adenovirus Type 4, and is an EPA-registered hospital disinfectant. According to CDC guidance, this product can be used to disinfect environmental surfaces in rooms of patients with suspected or confirmed virus infections.",
    ],
    sections: [
      {
        heading: "256 Century Q – Healthcare Disinfectant & Cleaner",
        paragraphs: [
          "A no-rinse, neutral pH, hospital disinfectant cleaner. 256 Century Q is efficacious against Rotavirus, Adenovirus Type 4, and is an EPA-registered hospital disinfectant. According to CDC guidance, this product can be used to disinfect environmental surfaces in rooms of patients with suspected or confirmed virus infections.",
        ],
      },
    ],
    images: [
      A("dilution-control/SM-DIL-005/256-century-q2L.webp"),
      A("dilution-control/SM-DIL-005/256-century-q2L.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-005/256centuryqspecUS-8-31-21.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-006": {
    title: "64 Millennium Q",
    lead: [
      "A multi-surface cleaner, tough on grease and sticky messes. 64 Millennium Q deodorizes areas which are generally hard to keep fresh smelling, such as empty garbage bins and cans toilet bowls, behind and under sinks, and other areas where bacterial growth can cause malodors.",
      "64 Millennium Q is a one step1,2 detergent disinfectant that is effective against a broad spectrum of bacteria, is viricidal* and inhibits the growth of mold and mildew and their odors when used as directed.",
      "1Non-food contact surfaces only.\n2When used according to disinfection directions.\n3Severe Acute Respiratory Syndrome Coronavirus",
    ],
    sections: [
      {
        heading: "Fast Kill Disinfectant",
        paragraphs: [
          "A multi-surface cleaner, tough on grease and sticky messes. 64 Millennium Q deodorizes areas which are generally hard to keep fresh smelling, such as empty garbage bins and cans toilet bowls, behind and under sinks, and other areas where bacterial growth can cause malodors.",
          "64 Millennium Q is a one step1,2 detergent disinfectant that is effective against a broad spectrum of bacteria, is viricidal* and inhibits the growth of mold and mildew and their odors when used as directed.",
          "1Non-food contact surfaces only.\n2When used according to disinfection directions.\n3Severe Acute Respiratory Syndrome Coronavirus",
        ],
      },
    ],
    images: [
      A("dilution-control/SM-DIL-006/64-Millennium-Q-Liter-1.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-006/64MillenniumQspecUS.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-007": {
    title: "DuoFill Dispenser",
    lead: [
      "Part number 421560",
    ],
    images: [
      A("dilution-control/SM-DIL-007/DuoFill-Dispenser.webp"),
      A("dilution-control/SM-DIL-007/DuoFill-Dispenser.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-007/DuoFill-Dispenser.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-008": {
    title: "Flex 4 Dispenser",
    lead: [
      "This unit accurately dispenses 4 high performance concentrates with the push of a button.",
      "Part Number: 421440",
    ],
    images: [
      A("dilution-control/SM-DIL-008/Flex-4-Dispenser.webp"),
      A("dilution-control/SM-DIL-008/Flex-4-Dispenser.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-008/Flex-4-Dispenser.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-009": {
    title: "QuadFill Dispenser",
    lead: [
      "Part number 421540",
    ],
    images: [
      A("dilution-control/SM-DIL-009/QuadFill-Dispenser.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-009/QuadFill-Dispenser.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-010": {
    title: "U-Fill Foamer",
    lead: [
      "Portable foaming gun allows quick and easy access to shower rooms for soap scum and mineral deposit removal.",
      "Part Number: 421740",
    ],
    images: [
      A("dilution-control/SM-DIL-010/U-Fill-Foamer.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-010/U-Fill-Foamer.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-DIL-011": {
    title: "U-Fill Sprayer",
    lead: [
      "Portable spraying gun allows quick and easy dispensing of Multi-Task concentrates.",
      "Part Number: 421750",
    ],
    images: [
      A("dilution-control/SM-DIL-011/U-Fill-Sprayer.webp"),
    ],
    pdfs: [
      {
        file: A("dilution-control/SM-DIL-011/U-Fill-Sprayer.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-RCE-001": {
    title: "Total Restroom System",
    sections: [
      {
        heading: "Parts and Instruction Manual",
        items: [
          "Parts and Instruction Manual",
        ],
      },
    ],
    images: [
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-01.webp"),
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-02.webp"),
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-03.webp"),
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-04.webp"),
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-05.webp"),
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-06.webp"),
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-07.webp"),
      A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-08.webp"),
    ],
    pdfs: [
      {
        file: A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("restroom-cleaners/SM-RCE-001/Total-Restroom-System-Parts-and-Instruction-Manual.pdf"),
        label: "Parts and Instruction Manual",
      },
      {
        file: A("restroom-cleaners/SM-RCE-001/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-RST-001": {
    title: "2300 Bowl Cleaner",
    lead: [
      "2300 BOWL CLEANER is an emulsion acid cleaner designed for stubborn problems on porcelain toilets and urinals. Heavy duty 23% hydrochloric acid cleaner.",
    ],
    images: [
      A("restroom-care/SM-RST-001/2300-Bowl-Cleaner.webp"),
    ],
    pdfs: [
      {
        file: A("restroom-care/SM-RST-001/2300-Bowl-Cleaner.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-RST-002": {
    title: "950 Bowl Cleaner",
    lead: [
      "950 Bowl Cleaner is thickened so that it clings to the sides and under the rim of bowls and urinals. This ability to adhere to vertical surfaces allows for better cleaning of surfaces compared to water thin products.",
    ],
    images: [
      A("restroom-care/SM-RST-002/950-Bowl-Cleaner.webp"),
      A("restroom-care/SM-RST-002/950-Bowl-Cleaner.webp"),
    ],
    pdfs: [
      {
        file: A("restroom-care/SM-RST-002/950-Bowl-Cleaner.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-RST-003": {
    title: "Foamy Mac – Restroom Cleaner",
    lead: [
      "Foamy MAC (Mild Acid Cleaner) with a new fresh citrus fragrance is an advanced foaming cleaner formulated to cling to surfaces when sprayed with a foaming trigger sprayer or a foam gun. Foamy MAC will clean soap scum, mineral deposits, lime or grease off of all acid resistant surfaces including shower stalls and bathtubs. Safe for use on chrome fixtures. Safe to work with, contains a low pH Organic Salt which is non-corrosive to skin. Letter of Guarantee",
    ],
    images: [
      A("restroom-care/SM-RST-003/Foamy-Mac-Restroom-Cleaner.webp"),
    ],
    pdfs: [
      {
        file: A("restroom-care/SM-RST-003/Foamy-Mac-Restroom-Cleaner-Guarantee.pdf"),
        label: "Letter of Guarantee",
      },
      {
        file: A("restroom-care/SM-RST-003/Foamy-Mac-Restroom-Cleaner.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-RST-004": {
    title: "Microcide TB",
    lead: [
      "A ready-to-use, one-step hospital germicidal disinfectant cleaner and deodorizer. Superior cleaning, great for cleaning all restroom surfaces. Highly effective against bacteria, antibiotic resistant bacteria, viruses and fungi. Effective against MRSA, HIV, HBV, HCV and Norovirus (Norwalk virus). EPA Registered.",
      "Multi-Clean has received EPA approval for 60 seconds efficacy against SARS-COV-2 the cause of COVID-19. For more information about the 2019 Novel Coronavirus (SARS-CoV-2, the cause of COVID-19), refer to the CDC website CDC.gov",
    ],
    images: [
      A("restroom-care/SM-RST-004/Microcide-TB.webp"),
      A("restroom-care/SM-RST-004/Microcide-TB.webp"),
    ],
  },
  "SM-RST-005": {
    title: "Multi-Scrub",
    lead: [
      "MULTI-SCRUB Creme Cleanser is an advanced cleaner formulated with a unique blend of surfactants, brighteners and mild abrasives that work together to achieve superior cleaning performance. Removes stubborn spots, soap-scum, grease and grime on all scratch resistant surfaces. Use on ceramic tiles, grout, drinking fountains, steam tables, sinks, counter tops, wash basins, shower stalls, bathtubs, toilet bowls, urinals, and any surfaces not harmed by mild abrasives.",
    ],
    images: [
      A("restroom-care/SM-RST-005/Multi-Scrub.webp"),
    ],
    pdfs: [
      {
        file: A("restroom-care/SM-RST-005/Multi-Scrub.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-RST-006": {
    title: "PP-Gone",
    lead: [
      "PP-Gone is a Peroxide Powered Cleaner that destroys urine odors and stains on hard and soft surfaces. PP-Gone is not just for hard surfaces, the dye free formula is safe on soft surfaces including carpet, bedding, mattresses, upholstery and clothing. It makes a great laundry pre-spot for urine and other stains. PP-Gone works effectively on human urine and animal urine odors and stains.",
      "12 quart case – Part Number 902578",
    ],
    images: [
      A("restroom-care/SM-RST-006/PP-Gone.webp"),
      A("restroom-care/SM-RST-006/PP-Gone.webp"),
    ],
    pdfs: [
      {
        file: A("restroom-care/SM-RST-006/PP-Gone.pdf"),
        label: "Learn More Here",
      },
    ],
  },
  "SM-WBF-001": {
    title: "EZ Mop 360 Microscrubber",
    lead: [
      "Walk behind floor scrubber with ultra maneuverable handling allowing a 360° effortless rotation. This very efficient design and 16’ scrub path cleans 5,400 square feet per hour. The 36 volt battery produces 1 hour of continuous run time. A true hybrid product between the mop and the scrubber, its extreme maneuverability eliminates unsightly dirty build up in hard to clean places. Compact but robust and reliable, guarantees many years of service. Its chassis is made of high-density stainless steal ( AISI 304L or A2: stainless steel food type) for a real professional use, designed for Cleaning Professionals.",
    ],
    sections: [
      {
        heading: "General Overview:",
        paragraphs: [
          "Walk behind floor scrubber with ultra maneuverable handling allowing a 360° effortless rotation. This very efficient design and 16’ scrub path cleans 5,400 square feet per hour. The 36 volt battery produces 1 hour of continuous run time. A true hybrid product between the mop and the scrubber, its extreme maneuverability eliminates unsightly dirty build up in hard to clean places. Compact but robust and reliable, guarantees many years of service. Its chassis is made of high-density stainless steal ( AISI 304L or A2: stainless steel food type) for a real professional use, designed for Cleaning Professionals.",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Lithium Ion Battery: 36 Volts",
          "Run Time: 1 hour",
          "Scrub width: 16.0″",
          "Squeegee width: 17.7 inches",
          "Pad / Brush pressure: 48.5 lbs.",
          "Brush Speed: 210 rpm",
          "Productivity: 5,400 square feet / hour",
          "Solution tank: .8 gallons",
          "Recovery tank: 1.3 gallons",
          "Vacuum motor: 36 volt / .40 h.p.",
          "Noise level: 66 dba",
        ],
      },
      {
        heading: "Parts, User & Service Manuals",
        items: [
          "Download Spare Parts Catalog",
          "Download User Manual",
        ],
      },
    ],
    images: [
      A("walk-behind-floor-scrubbers/SM-WBF-001/EZ-Mop-360-Microscrubber.webp"),
    ],
    pdfs: [
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-001/EZ-Mop-360-Microscrubber-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-001/EZ-Mop-360-Microscrubber-Spare-Parts-Catalog.pdf"),
        label: "Download Spare Parts Catalog",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-001/EZ-Mop-360-Microscrubber-User-Manual.pdf"),
        label: "Download User Manual",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-001/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-WBF-002": {
    title: "Port a Scrub 12",
    sections: [
      {
        heading: "Key Features:",
        items: [
          "12-inch cleaning path allows for use where other floor scrubbers cannot reach or fit",
          "Counter-rotating cylindrical brushes allow the Port A Scrub 12 to glide back and forth in forward or reverse operation",
          "The Port A Scrub has four height settings for brush wear and brush height",
          "Brushes require no tools to change or remove",
          "One gallon clean water tank is conveniently located on the handle and is easily removed for quick filling",
          "Three optional brush choices for various hard and soft surface cleaning",
          "Transport cart for easy movement from one job to another",
          "Side brush optional for easy cleaning along walls, under cabinets, corners and other hard to reach places",
        ],
      },
      {
        heading: "General Overview",
        items: [
          "Compact and versatile cleaning machine excels on virtually any type of hard floor including vinyl, tile, hardwood, concrete, short nap carpeting, diamond plate, quarry tile, brick, slate, mosaic, studded rubber, granite, marble, rubber floors, escalators and people movers",
          "Operator-friendly and extremely maneuverable",
          "Scrubs with two counter-rotating cylindrical brushes and picks up the dirty water in one pass",
          "A 12-inch path helps the Port A Scrub to be used in congested areas while leaving the floor virtually dry for traffic",
        ],
      },
      {
        heading: "Ease of Use",
        items: [
          "Easy controls require minimal training",
          "Compact design allows the machine to operate in small spaces that other scrubbers cannot go",
          "Great maneuverability",
          "Simply lower the handle and the machine turns on and is ready to go",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Brush Speed: 650 rpm",
          "Cleaning Width: 12″",
          "Height: 44″ (111cm)",
          "Height without handle: 8″ (20 cm)",
          "Length: 15″ (38 cm)",
          "Noise Level: 69db",
          "Performance: 3,770 Square feet per hour(350 mu00b2)",
          "Power cord: 40′ 18 gauge 3 wire",
          "Solution Capacity: 1 Gal. (4 liters)",
          "Weight: 55 lbs. (25 kg)",
          "Battery unit available",
        ],
      },
      {
        heading: "Green Features",
        items: [
          "Dirty water pick up leaves the floor virtually dry for traffic",
          "Low noise level of 69 db makes the machine safe to use in noise sensitive areas",
          "40 foot, 18-gauge 3-wire cord",
        ],
      },
      {
        heading: "Spare Parts and Instruction Catalog",
        items: [
          "Port-A-Scrub 12 Electric Parts and Instruction Manual",
          "Port-A-Scrub 12 Battery Parts and Instruction Manual",
        ],
      },
    ],
    images: [
      A("walk-behind-floor-scrubbers/SM-WBF-002/Port-a-Scrub-12.webp"),
    ],
    pdfs: [
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-002/Port-a-Scrub-12-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-002/Port-A-Scrub-12-Electric-Parts-and-Instruction-Manual.pdf"),
        label: "Port-A-Scrub 12 Electric Parts and Instruction Manual",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-002/Port-A-Scrub-12-Battery-Parts-and-Instruction-Manual.pdf"),
        label: "Port-A-Scrub 12 Battery Parts and Instruction Manual",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-002/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-WBF-003": {
    title: "Scrubmaster B5",
    lead: [
      "The Scrubmaster B5 makes surfaces accessible for machine assisted cleaning that could previously only be reached with a mop.",
      "The Scrubmaster B5 does so with great mobility, excellent maneuverability, and little physical effort on the part of the user. Thanks to the innovative Delta Cleaning System the operator can determine the working speed at any time and precisely approach narrow areas and corners.",
      "The flat cleaning head is designed in such a way that cleaning close to walls, deep into corners and under furniture and substructures with an under clearance of as little as 4.72″ is possible. Low water and power consumption and offers a silent mode for noise sensitive areas.",
    ],
    sections: [
      {
        heading: "General Overview:",
        paragraphs: [
          "The Scrubmaster B5 makes surfaces accessible for machine assisted cleaning that could previously only be reached with a mop.",
          "The Scrubmaster B5 does so with great mobility, excellent maneuverability, and little physical effort on the part of the user. Thanks to the innovative Delta Cleaning System the operator can determine the working speed at any time and precisely approach narrow areas and corners.",
        ],
      },
      {
        heading: "Downloads",
        items: [
          "Quick Reference Guide",
        ],
      },
      {
        heading: "General Overview",
        paragraphs: [
          "The flat cleaning head is designed in such a way that cleaning close to walls, deep into corners and under furniture and substructures with an under clearance of as little as 4.72″ is possible. Low water and power consumption and offers a silent mode for noise sensitive areas.",
        ],
        items: [
          "Cleans Close to Walls, Deep into Corners, and Under Obstacles",
          "Delta-Cleaning System with Neutral Forward Drive",
          "Low Water and Power Consumption",
          "Silent Mode for Noise Sensitive Areas",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Technical Data: SM17QP",
          "Working width scrubbing: 17 in",
          "Width squeegee: 22 in",
          "Theoretical area performance: 1400 ft²/h",
          "Power Source: Battery",
          "Traction Drive: No",
          "Type of brushes: Orbital",
          "No. of brushes: 1",
          "Brush diameter: 17 in",
          "Brush speed in rpm: 1450/1880",
          "Brush pressure: 44 lb",
          "Solution tank in gallons: 1.3 gallons",
          "Rated voltage: 24 Volts",
          "Rated power – brush motor: 200 Watts",
          "Rated power – suction motor: 260 Watts",
          "Battery capacity: 12.8 Ah",
          "Theoretical Runtime: 60 min",
          "Practical Runtime: 45 min",
          "Length: 23.6 in",
          "Width squeegee: 19/22 in",
          "Height: 46 in",
          "Weight w/o battery: 44 lb",
          "Gross weight with battery: 59.5 lb",
          "Noise level: 68/68 dB(A)",
        ],
      },
      {
        heading: "Parts, User & Service Manuals",
        items: [
          "Scrubmaster B5 Parts Manual",
          "Scrubmaster B5 User Manual",
        ],
      },
    ],
    images: [
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-1.webp"),
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-2.webp"),
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-3.webp"),
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-4.webp"),
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-5.webp"),
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-6.webp"),
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-1.webp"),
      A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-2.webp"),
    ],
    pdfs: [
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-Quick-Reference-Guide.pdf"),
        label: "Quick Reference Guide",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-Parts-Manual.pdf"),
        label: "Scrubmaster B5 Parts Manual",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-003/Scrubmaster-B5-User-Manual.pdf"),
        label: "Scrubmaster B5 User Manual",
      },
      {
        file: A("walk-behind-floor-scrubbers/SM-WBF-003/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-WBS-001": {
    title: "Kleen Sweep 25W",
    sections: [
      {
        heading: "General Overview:",
        items: [
          "25” walk-behind carpet sweeper",
          "Hopper capacity 1.06 cubic feet",
          "Excellent performance on carpeted or hard floor areas",
          "Ergonomically shaped, adjustable handle for ease-of-use",
          "Easy serviceabilty with open access to components",
          "24 Volt battery powered",
          "Dust filter is extremely efficient (99.97% @ 3 Microns)",
          "Quiet operation at 63 decibels or less",
          "One-button operation",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Battery: 24V 40 Ah gel battery (4)",
          "Broom Material: Synthetic",
          "Charger: On-Board",
          "Dust Filter: 99.97% efficient at 3 microns",
          "Filter Material: Polyester",
          "Filter Removal: Tools Free",
          "Filter Shaker: Manual",
          "Flaps: Non-marking",
          "Hopper Capacity: 1.06 cubic feet",
          "Main Broom: 16 in",
          "Noise Level: 63db",
          "Side Broom: 11 in",
        ],
      },
      {
        heading: "Parts and User Manuals",
        items: [
          "Kleen Sweep 25W Parts Manual",
          "Kleen Sweep 25W User Manual",
        ],
      },
    ],
    images: [
      A("walk-behind-sweepers/SM-WBS-001/Kleen-Sweep-25W.webp"),
    ],
    pdfs: [
      {
        file: A("walk-behind-sweepers/SM-WBS-001/Kleen-Sweep-25W.pdf"),
        label: "Download Lit",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-001/Kleen-Sweep-25W-Parts-Manual.pdf"),
        label: "Kleen Sweep 25W Parts Manual",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-001/Kleen-Sweep-25W-User-Manual.pdf"),
        label: "Kleen Sweep 25W User Manual",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-001/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-WBS-002": {
    title: "Kleen Sweep 27",
    sections: [
      {
        heading: "Key Features:",
        items: [
          "A shock-proof steel frame, sturdy aluminum housing, and strong synthetic hopper make the KS27R walk behind floor sweeper great for use in any environment",
          "Compact design fits through any standard door and can be used inside and outside",
          "Main broom and side brush can be adjusted for optimum adaptation to floor conditions and type of dirt",
        ],
      },
      {
        heading: "General Overview",
        items: [
          "The KS27R is an ideal replacement for manual sweeping",
          "Picks up dirt quickly without leaving dust behind",
          "Lightweight and convenient, yet virtually indestructible",
          "Great for workshops, outdoor areas, paths, machine shops, stockrooms, parks, small yards, parking areas and loading ramps",
          "Goes where large sweepers cannot",
          "The KS27R sweeps up to 24,757 sq. ft. per hour",
          "Works up to ten times faster than manual sweeping with a dustpan and brush",
        ],
      },
      {
        heading: "Ease of Use",
        items: [
          "Stairs and curbs can be climbed easily due to the large rear wheels.",
          "Optimum position of the handle allows the operator to use the position that is most comfortable as it can be easily switched around",
          "Dirt Hopper can be removed and replaced easily utilizing the handle",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Height: 35 in (900mm)",
          "Length: 52 in (1330mm)",
          "Performance: 24,757sq ft (2,300sq m)",
          "Weight: 31 in (790mm)",
        ],
      },
      {
        heading: "Parts and Instruction Manual",
        items: [
          "Kleen Sweep 27 Parts and Instruction Manual",
        ],
      },
    ],
    images: [
      A("walk-behind-sweepers/SM-WBS-002/Kleen-Sweep-27.webp"),
    ],
    pdfs: [
      {
        file: A("walk-behind-sweepers/SM-WBS-002/Kleen-Sweep-27.pdf"),
        label: "Download Lit",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-002/Kleen-Sweep-27-Parts-and-Instruction-Manual.pdf"),
        label: "Kleen Sweep 27 Parts and Instruction Manual",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-002/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
  "SM-WBS-003": {
    title: "Kleen Sweep 28",
    sections: [
      {
        heading: "Key Features:",
        items: [
          "Compact design fits through any standard door and can be used inside and outside",
          "Main broom and side brush can be adjusted for optimum adaptation to floor conditions and type of dirt, they also operate independently of each other allowing use of main broom without side broom",
          "Dust filter is extremely efficient (99.9% @ 3 microns)",
          "On-board charger for quick and convenient charging",
          "Overthrow hopper for greater capacity",
          "TAKE-IT-EASY hopper system for comfortable emptying",
          "Maintenance free battery system w/on board charger",
          "Swiveling handle bar for easy opening & removal of the dirt hopper",
        ],
      },
      {
        heading: "General Overview",
        items: [
          "28” sweep path",
          "Picks up dirt quickly without leaving dust behind",
          "Extremely durable floor sweeper constructed of rotomolded plastic and 12 gauge steel frame",
          "Great for schools, universities, airports, hospitals,health clubs, casinos, office buildings, hotels,resorts, and government facilities",
          "Excellent performance on carpeted or hard floor area",
        ],
      },
      {
        heading: "Specifications",
        items: [
          "Size: 47.2″L x 27.2″W x 28.3″H",
          "Battery: Maintenance Free 12V",
          "Charger: On-Board",
          "Broom Material: Synthetic",
          "Brush Type: Cylindrical",
          "Number of Brushes: 1 Main Broom, 1 Side Broom",
          "Main Broom Width: 20.1″",
          "Side Broom Width: 15.8″",
          "Dust Filter: Yes",
          "Filter Material: Synthetic",
          "Filter Removal: Without Tools",
          "Filter Shaker: Manual",
          "Flaps: Non-marking",
          "Hopper Capacity: 9.2 gallons",
          "Noise Level: < = 68 dB (A)",
          "Power cord: On-Board Charger",
          "Weight: 269 lbs",
          "Weight without drive/batteries: 225 lbs",
          "Working Speed: 3.1 mph",
        ],
      },
      {
        heading: "Green Features",
        items: [
          "Ergonomically shaped, adjustable handle",
          "One button operation",
          "Quiet operation at 63 decibels or less",
          "Dust filter is extremely efficient (99.9% @ 3 microns)",
          "Carpet care kit is standard on all units",
          "Powerful dust control system w/easy filter access",
        ],
      },
      {
        heading: "Parts, User & Service Manuals",
        items: [
          "Kleen Sweep 28 Parts Manual",
          "Kleen Sweep 28 User Manual",
        ],
      },
    ],
    images: [
      A("walk-behind-sweepers/SM-WBS-003/Kleen-Sweep-28.webp"),
    ],
    pdfs: [
      {
        file: A("walk-behind-sweepers/SM-WBS-003/Kleen-Sweep-28-Brochure.pdf"),
        label: "Download Brochure",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-003/Kleen-Sweep-28-Lit.pdf"),
        label: "Download Lit",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-003/Kleen-Sweep-28-Parts-Manual.pdf"),
        label: "Kleen Sweep 28 Parts Manual",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-003/Kleen-Sweep-28-User-Manual.pdf"),
        label: "Kleen Sweep 28 User Manual",
      },
      {
        file: A("walk-behind-sweepers/SM-WBS-003/Minuteman-warranty-revW.pdf"),
        label: "Warranty Policy",
      },
    ],
  },
};

export function getProductDetails(sku) {
  return JANITORIAL_MANUAL_DETAILS[sku] || JANITORIAL_PRODUCT_DETAILS[sku] || null;
}
